import Icon from '../components/Icon.vue'

Icon.register({
  code: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9l136.5-470.2c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9l-136.5 470.2c-1.9 6.4-8.5 10.1-14.9 8.2zM164.9 399.3c-4.5 4.9-12.1 5.1-17 0.5l-144.1-135.1c-5.1-4.7-5.1-12.8 0-17.5l144.1-135c4.9-4.6 12.5-4.3 17 0.5l43.5 46.4c4.7 4.9 4.3 12.7-0.8 17.2l-90.6 79.7 90.6 79.7c5.1 4.5 5.4 12.3 0.8 17.2zM492.1 399.9c-4.9 4.5-12.5 4.3-17-0.6l-43.5-46.4c-4.7-4.9-4.3-12.7 0.8-17.2l90.6-79.7-90.6-79.8c-5.1-4.5-5.4-12.3-0.8-17.2l43.5-46.4c4.6-4.8 12.2-5 17-0.5l144.1 135.2c5.1 4.7 5.1 12.8 0 17.5z'
      }
    ]
  }
})
